import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import et from "../util/browser-detector.js";
import Ie from "../models/device.js";
import DeviceProperties from "../Core/device-properties.js";
import _t from "../models/identifier.js";
import r from "../../shared-lib/braze-shared-lib.js";
import { STORAGE_KEYS as o } from "../managers/storage-manager.js";
import { values as At } from "../util/code-utils.js";

var It = /*#__PURE__*/function () {
  function It(e, t) {
    _classCallCheck(this, It);

    this.h = e, null == t && (t = At(DeviceProperties)), this.xo = t;
  }

  _createClass(It, [{
    key: "te",
    value: function te() {
      var e = this.h.tu(o.iu.Go);
      null == e && (e = new _t(r.it.nt()), this.h.ru(o.iu.Go, e));
      var t = new Ie(e.eu);

      for (var _e = 0; _e < this.xo.length; _e++) {
        var _r = this.xo[_e];

        switch (_r) {
          case DeviceProperties.BROWSER:
            t[_r] = et.browser;
            break;

          case DeviceProperties.BROWSER_VERSION:
            t[_r] = et.version;
            break;

          case DeviceProperties.OS:
            t[_r] = this.Fo();
            break;

          case DeviceProperties.RESOLUTION:
            t[_r] = screen.width + "x" + screen.height;
            break;

          case DeviceProperties.LANGUAGE:
            t[_r] = et.language;
            break;

          case DeviceProperties.TIME_ZONE:
            t[_r] = this.Jo(new Date());
            break;

          case DeviceProperties.USER_AGENT:
            t[_r] = et.userAgent;
        }
      }

      return t;
    }
  }, {
    key: "Fo",
    value: function Fo() {
      if (et.qo()) return et.qo();
      var e = this.h.I(o.q.Ho);
      return e && e.os_version ? e.os_version : et.Ko();
    }
  }, {
    key: "Jo",
    value: function Jo(e) {
      if ("undefined" != typeof Intl && "function" == typeof Intl.DateTimeFormat) try {
        if ("function" == typeof Intl.DateTimeFormat().resolvedOptions) {
          var _e2 = Intl.DateTimeFormat().resolvedOptions().timeZone;
          if (null != _e2 && "" !== _e2) return _e2;
        }
      } catch (e) {
        r.D.info("Intl.DateTimeFormat threw an error, probably https://bugs.chromium.org/p/chromium/issues/detail?id=811403, falling back to GTM offset: " + e.message);
      }
      var t = e.getTimezoneOffset();
      return this.Qo(t);
    }
  }, {
    key: "Qo",
    value: function Qo(e) {
      var t = parseInt(e / 60),
          r = parseInt(e % 60);
      var s = "GMT";
      return 0 !== e && (s += e < 0 ? "+" : "-", s += ("00" + Math.abs(t)).slice(-2) + ":" + ("00" + Math.abs(r)).slice(-2)), s;
    }
  }]);

  return It;
}();

export { It as default };